import { WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { PunchOutSupplierIconStyled } from './styles/PunchOutSupplierIconStyled'

export interface IPunchOutSupplierIconProps {
  /**
   * Sets the supplier icon size
   */
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  /**
   * PunchOut supplier name
   */
  name: string
  /**
   * PunchOut supplier icon url
   */
  iconUrl: string
}

export const PunchOutSupplierIcon = ({
  size = 'medium',
  name,
  iconUrl,
}: IPunchOutSupplierIconProps) => {
  const intl = useProcurifyIntl()

  return iconUrl && name ? (
    <PunchOutSupplierIconStyled size={size}>
      <WithTooltip title={name} placement='top'>
        <img
          src={iconUrl}
          alt={intl.formatMessage(messages.imageAltText, {
            name,
          })}
        />
      </WithTooltip>
    </PunchOutSupplierIconStyled>
  ) : null
}

PunchOutSupplierIcon.displayName = 'PunchOutSupplierIcon'
